export const getPathWithUpdatedSearchParams = (updateSearchParams: (_: URLSearchParams) => void) => {
  const url = new URL(window.location.href)
  updateSearchParams(url.searchParams)
  return url.pathname + url.search
}

export const getPathWithSearchParam = (key: string, value: string): string =>
  getPathWithUpdatedSearchParams((searchParams) => {
    searchParams.delete(key)
    if (value != '') searchParams.set(key, value)
  })
